import useResponsive from './useResponsive';
import QUERIES from './queries';

export { QUERIES };
export default useResponsive;
